import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import frCommon from './locales/fr/common.json';
import enCommon from './locales/en/common.json';
import arCommon from './locales/ar/common.json';

const LANGUAGE_STORAGE_KEY = 'app_lang';
const supportedLanguages = ['fr', 'en', 'ar'] as const;
type SupportedLanguage = (typeof supportedLanguages)[number];

const getInitialLanguage = (): SupportedLanguage => {
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored && supportedLanguages.includes(stored as SupportedLanguage)) {
    return stored as SupportedLanguage;
  }

  const navLang = (navigator.language || 'fr').split('-')[0];
  if (supportedLanguages.includes(navLang as SupportedLanguage)) {
    return navLang as SupportedLanguage;
  }

  return 'fr';
};

const applyDocumentDirection = (language: string) => {
  const dir = language === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = language;
  document.documentElement.dir = dir;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { common: frCommon },
      en: { common: enCommon },
      ar: { common: arCommon },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'fr',
    supportedLngs: [...supportedLanguages],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

applyDocumentDirection(i18n.language);

i18n.on('languageChanged', (language) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  applyDocumentDirection(language);
});

export default i18n;
